import React from 'react';

import { Outlet } from 'react-router';

import { useCurrentUserPermissions } from 'src/hooks/user';
import {
  AccountLayout,
  AccountLayoutConsumer,
  AccountLayoutEmployerAdmin,
  AccountLayoutEmployerManager,
  AccountLayoutPEOPayrollProvider,
  AccountLayoutVerifierAdmin,
  AccountLayoutVerifierManager,
} from 'src/layouts';
import { AccountLayoutClearVerifyAdmin } from 'src/layouts/AccountLayoutClearVerifyAdmin';
import { AccountLayoutPEOAdmin } from 'src/layouts/AccountLayoutPEOAdmin';

export const AccountLayoutResolver: React.FC = () => {
  const {
    isEmployerManager,
    isEmployerAdmin,
    isVerifierAdmin,
    isVerifierManager,
    isPlatformAdmin,
    isEmployee,
    isPeoSuperAdmin,
    isPeoAdmin,
    isPeoPayrollProviderUser,
  } = useCurrentUserPermissions();

  if (isPlatformAdmin) {
    return (
      <AccountLayoutClearVerifyAdmin>
        <Outlet />
      </AccountLayoutClearVerifyAdmin>
    );
  }

  if (isEmployerAdmin) {
    return (
      <AccountLayoutEmployerAdmin>
        <Outlet />
      </AccountLayoutEmployerAdmin>
    );
  }

  if (isEmployerManager) {
    return (
      <AccountLayoutEmployerManager>
        <Outlet />
      </AccountLayoutEmployerManager>
    );
  }

  if (isVerifierAdmin) {
    return (
      <AccountLayoutVerifierAdmin>
        <Outlet />
      </AccountLayoutVerifierAdmin>
    );
  }

  if (isVerifierManager) {
    return (
      <AccountLayoutVerifierManager>
        <Outlet />
      </AccountLayoutVerifierManager>
    );
  }

  if (isEmployee) {
    return (
      <AccountLayoutConsumer>
        <Outlet />
      </AccountLayoutConsumer>
    );
  }

  if (isPeoSuperAdmin || isPeoAdmin) {
    return (
      <AccountLayoutPEOAdmin>
        <Outlet />
      </AccountLayoutPEOAdmin>
    );
  }

  if (isPeoPayrollProviderUser) {
    return (
      <AccountLayoutPEOPayrollProvider>
        <Outlet />
      </AccountLayoutPEOPayrollProvider>
    );
  }

  return (
    <AccountLayout>
      <Outlet />
    </AccountLayout>
  );
};
